import SettingsService from '_services/rest/modules/settings';

export default {
  state: {
    company: null,
    messages: null,
    settings: null,
  },
  mutations: {
    setCompany(state, response) {
      state.company = response;
    },
    setMessages(state, response) {
      state.messages = response;
    },
    setSettings(state, response) {
      state.settings = response;
    },
  },
  actions: {
    getSettings({ commit }) {
      return SettingsService.getSettings()
        .then(response => {
          commit('setCompany', response.company);
          commit('setMessages', response.message);
          commit('setSettings', response.settings);
        });
    },
  },
};
